import React from 'react';
import { NumberBox } from 'devextreme-react/number-box';
import cs from '../../../utils/const.js';
import { resolveServiceRoutingHeaders } from '../../../utils/AntServiceRouting';
import { t } from '../i18n';

// Mirror ProductTablePanel — upload ảnh/PDF/Excel bảng giá lịch slot → AI extract slots.
// Schema: panelData = { rows: [{ slot_code, slot_name, start_hour, end_hour, weekday_price, weekend_price }] }

function _resolveAPIContext() {
    var BaseURL = null;
    try { BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL'); } catch (e) { /* ignore */ }
    if (!BaseURL || BaseURL === 'null' || BaseURL === 'undefined') BaseURL = cs.BaseURL;

    var token = '';
    var info = {};
    try { token = localStorage.getItem(cs.System_Code + '-session-token') || ''; } catch (e) { /* ignore */ }
    try {
        var raw = localStorage.getItem(cs.System_Code + '-session-info');
        if (raw) info = JSON.parse(raw) || {};
    } catch (e) { info = {}; }

    var headers = {
        Authorization: 'Bearer ' + token,
        'Business-Short-Code': info.business_short_code || '',
        'Business-Zone-Code': info.business_zone_code || '',
        'Business-Industry': info.business_industry || '',
        'Business-Sub-Industry': info.business_sub_industry || '',
        ...resolveServiceRoutingHeaders(info)
    };
    return { baseURL: BaseURL || '', headers: headers };
}

export function validateSlots(rows, locale) {
    var L = {
        codeRequired: t(locale, 'p_slot_code_required'),
        invalidHour: t(locale, 'p_hour_invalid'),
        invalidRange: t(locale, 'p_hour_range'),
        invalidPrice: t(locale, 'p_price_invalid')
    };

    var rowErrors = {};
    var validCount = 0;
    rows.forEach(function (r, idx) {
        var code = String(r && r.slot_code || '').trim();
        var startStr = String(r && r.start_hour || '').trim();
        var endStr = String(r && r.end_hour || '').trim();
        var wPrice = r && r.weekday_price;
        if (!code && !startStr && !endStr && !wPrice) return; // empty — skip
        if (!code) { rowErrors[idx] = L.codeRequired; return; }
        if (!_validHour(startStr)) { rowErrors[idx] = L.invalidHour; return; }
        if (!_validHour(endStr)) { rowErrors[idx] = L.invalidHour; return; }
        if (endStr <= startStr) { rowErrors[idx] = L.invalidRange; return; }
        var wp = Number(wPrice);
        if (!Number.isFinite(wp) || wp < 0) { rowErrors[idx] = L.invalidPrice; return; }
        validCount++;
    });

    var errors = [];
    Object.keys(rowErrors).forEach(function (k) {
        var msg = rowErrors[k];
        if (errors.indexOf(msg) === -1) errors.push(msg);
    });
    return { errors: errors, rowErrors: rowErrors, validCount: validCount };
}

function _validHour(s) {
    if (!s) return false;
    return /^\d{1,2}:\d{2}(:\d{2})?$/.test(s);
}

var ALLOWED_MIMES = [
    'image/jpeg', 'image/jpg', 'image/png', 'image/webp',
    'application/pdf',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/csv'
];
var ALLOWED_EXT = ['.jpg', '.jpeg', '.png', '.webp', '.pdf', '.xls', '.xlsx', '.csv'];
var MAX_SIZE = 10 * 1024 * 1024;

function _hasAllowedExt(name) {
    if (!name) return false;
    var lower = String(name).toLowerCase();
    for (var i = 0; i < ALLOWED_EXT.length; i++) {
        if (lower.endsWith(ALLOWED_EXT[i])) return true;
    }
    return false;
}

export default class SlotTablePanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uploading: false,
            uploadError: null,
            uploadNote: null,
            dragOver: false,
            currencyCode: props.currency || '',
            preloading: false
        };
        this.fileInputRef = React.createRef();
    }

    componentDidMount() {
        // Pre-fill với slots đã có sẵn (do Item.generateData seed) để user chỉ cần edit giá.
        // Chỉ fetch khi rows hiện tại empty (user chưa từng nhập gì).
        var cur = (this.props.value && this.props.value.rows) || [];
        if (cur.length > 0) return;
        var self = this;
        self.setState({ preloading: true });
        var ctx = _resolveAPIContext();
        var url = (ctx.baseURL || '') + '/item/ItemShiftSlot/list';
        fetch(url, {
            method: 'POST',
            headers: Object.assign({ 'Content-Type': 'application/json' }, ctx.headers),
            credentials: 'include',
            body: JSON.stringify({ item_code: 'SlotService', is_active: 1, total: false })
        }).then(function (resp) { return resp.json(); }).then(function (json) {
            var payload = (json && json.data) ? json.data : json;
            var arr = [];
            if (Array.isArray(payload)) arr = payload;
            else if (Array.isArray(payload && payload.rows)) arr = payload.rows;
            if (arr.length === 0) { self.setState({ preloading: false }); return; }
            arr.sort(function (a, b) {
                return String(a.start_hour || '').localeCompare(String(b.start_hour || ''));
            });
            var rows = arr.map(function (r) {
                return {
                    slot_code: r.slot_code || '',
                    slot_name: r.slot_name || r.slot_code || '',
                    start_hour: r.start_hour || '',
                    end_hour: r.end_hour || '',
                    weekday_price: Number(r.monday_unit_price || 0),
                    weekend_price: Number(r.saturday_unit_price || r.sunday_unit_price || r.monday_unit_price || 0)
                };
            });
            self.props.onChange({ rows: rows });
            self.setState({ preloading: false });
        }).catch(function () {
            self.setState({ preloading: false });
        });
    }

    update(idx, key, val) {
        var rows = (this.props.value && this.props.value.rows) || [];
        var next = rows.map(function (r, i) {
            return i === idx ? Object.assign({}, r, { [key]: val }) : r;
        });
        this.props.onChange({ rows: next });
    }

    add() {
        var rows = (this.props.value && this.props.value.rows) || [];
        var lastEnd = '06:00:00';
        if (rows.length > 0) {
            var last = rows[rows.length - 1];
            if (last && last.end_hour) lastEnd = last.end_hour;
        }
        var startH = parseInt(String(lastEnd).slice(0, 2), 10);
        if (!Number.isFinite(startH)) startH = 6;
        var endH = Math.min(startH + 2, 23);
        var pad = function (n) { return String(n).padStart(2, '0'); };
        var startHour = pad(startH) + ':00:00';
        var endHour = pad(endH) + ':00:00';
        var slotCode = 'SLOT-' + pad(startH) + '-' + pad(endH);
        var next = rows.concat([{
            slot_code: slotCode,
            slot_name: '',
            start_hour: startHour,
            end_hour: endHour,
            weekday_price: 0,
            weekend_price: 0
        }]);
        this.props.onChange({ rows: next });
    }

    remove(idx) {
        var rows = (this.props.value && this.props.value.rows) || [];
        this.props.onChange({ rows: rows.filter(function (_, i) { return i !== idx; }) });
    }

    handleFile(file) {
        var locale = this.props.locale || 'vi';
        var T = {
            tooLarge: t(locale, 'p_file_too_large'),
            unsupported: t(locale, 'p_file_unsupported'),
            failed: t(locale, 'p_ai_read_failed'),
            emptyPlan: t(locale, 'p_ai_empty_plan'),
            aiDisabled: t(locale, 'p_ai_disabled')
        };

        var mapErr = function (raw) {
            if (!raw) return null;
            var s = String(raw).toLowerCase();
            if (s.indexOf('ai_not_configured') >= 0) return T.aiDisabled;
            if (s.indexOf('empty_plan') >= 0) return T.emptyPlan;
            if (s.indexOf('file_too_large') >= 0) return T.tooLarge;
            if (s.indexOf('unsupported_mime') >= 0) return T.unsupported;
            return null;
        };

        if (!file) return;
        if (file.size > MAX_SIZE) {
            this.setState({ uploadError: T.tooLarge, uploadNote: null });
            return;
        }
        var mime = (file.type || '').toLowerCase();
        if (ALLOWED_MIMES.indexOf(mime) < 0 && !_hasAllowedExt(file.name)) {
            this.setState({ uploadError: T.unsupported, uploadNote: null });
            return;
        }

        var rows = (this.props.value && this.props.value.rows) || [];

        var fd = new FormData();
        fd.append('file', file);
        fd.append('locale', locale);

        var self = this;
        self.setState({ uploading: true, uploadError: null, uploadNote: null });
        var ep = '/setting/SysSetupWizard/aiSuggestSlotPlan';
        var ctx = _resolveAPIContext();
        var queryURL = (ctx.baseURL || '') + ep;
        fetch(queryURL, {
            method: 'POST',
            body: fd,
            headers: ctx.headers,
            credentials: 'include'
        }).then(function (resp) {
            return resp.json();
        }).then(function (json) {
            var payload = (json && json.data) ? json.data : json;
            var pickI18n = function (v) {
                if (v == null) return null;
                if (typeof v === 'string') return v;
                if (typeof v === 'object') return v[locale] || v.en || v.vi || Object.values(v)[0] || null;
                return String(v);
            };
            if (!payload || !payload.ok) {
                var rawErr = (payload && payload.error) || (payload && payload.detail);
                var errMsg = mapErr(rawErr) || pickI18n(payload && payload.detail) || T.failed;
                self.setState({ uploading: false, uploadError: errMsg, uploadNote: null });
                return;
            }
            // Merge rows: skip dup slot_code (case-insensitive trim)
            var existingLower = {};
            rows.forEach(function (r) {
                var code = String(r && r.slot_code || '').trim().toLowerCase();
                if (code) existingLower[code] = true;
            });
            var added = 0;
            var newRows = rows.slice();
            (payload.rows || []).forEach(function (r) {
                var code = String(r.slot_code || '').trim();
                if (!code) return;
                if (existingLower[code.toLowerCase()]) return;
                newRows.push({
                    slot_code: code,
                    slot_name: String(r.slot_name || code).trim(),
                    start_hour: String(r.start_hour || '').trim(),
                    end_hour: String(r.end_hour || '').trim(),
                    weekday_price: Number(r.weekday_price) || 0,
                    weekend_price: Number(r.weekend_price) || 0,
                    _source: 'ai'
                });
                added++;
            });
            // Sort by start_hour
            newRows.sort(function (a, b) {
                return String(a.start_hour || '').localeCompare(String(b.start_hour || ''));
            });
            self.props.onChange({ rows: newRows });
            var noteText = pickI18n(payload.note);
            self.setState({
                uploading: false,
                uploadError: null,
                uploadNote: noteText || ('AI: ' + added),
                currencyCode: payload.currency_code || self.state.currencyCode
            });
            if (self.fileInputRef.current) self.fileInputRef.current.value = '';
        }).catch(function () {
            self.setState({ uploading: false, uploadError: T.failed, uploadNote: null });
        });
    }

    onDrop(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ dragOver: false });
        var files = e.dataTransfer && e.dataTransfer.files;
        if (files && files[0]) this.handleFile(files[0]);
    }

    onDragOver(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!this.state.dragOver) this.setState({ dragOver: true });
    }

    onDragLeave(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ dragOver: false });
    }

    onPickFile(e) {
        var files = e.target && e.target.files;
        if (files && files[0]) this.handleFile(files[0]);
    }

    onPaste(e) {
        var items = e.clipboardData && e.clipboardData.items;
        if (!items) return;
        for (var i = 0; i < items.length; i++) {
            if (items[i].kind === 'file') {
                var file = items[i].getAsFile();
                if (file) {
                    this.handleFile(file);
                    e.preventDefault();
                    return;
                }
            }
        }
    }

    render() {
        var locale = this.props.locale || 'vi';
        var rows = (this.props.value && this.props.value.rows) || [];
        var aiReady = this.props.aiReady !== false;
        var v = validateSlots(rows, locale);

        var L = {
            colCode: t(locale, 'p_col_code'),
            colName: t(locale, 'p_col_slot_name'),
            colStart: t(locale, 'p_col_start'),
            colEnd: t(locale, 'p_col_end'),
            colWeekday: t(locale, 'p_col_weekday'),
            colWeekend: t(locale, 'p_col_weekend'),
            addRow: '+ ' + t(locale, 'p_add_slot'),
            dropHint: t(locale, 'p_drop_slots'),
            uploadingMsg: t(locale, 'p_reading_file'),
            aiDisabled: t(locale, 'p_ai_disabled'),
            pickFile: t(locale, 'p_pick_file'),
            currencyLabel: t(locale, 'p_currency')
        };

        var dropClass = 'wiz-slots__dropzone';
        if (this.state.dragOver) dropClass += ' wiz-slots__dropzone--over';
        if (!aiReady) dropClass += ' wiz-slots__dropzone--disabled';
        if (this.state.uploading) dropClass += ' wiz-slots__dropzone--uploading';

        var self = this;
        var currencyVal = this.state.currencyCode || this.props.currency || '';

        return (
            <div className="wiz-slots" onPaste={this.onPaste.bind(this)}>
                {currencyVal ? (
                    <div className="wiz-slots__currency">
                        <span className="wiz-slots__currency-label">{L.currencyLabel}:</span>
                        <span className="wiz-slots__currency-code">{currencyVal}</span>
                    </div>
                ) : null}

                <div
                    className={dropClass}
                    onDrop={aiReady ? this.onDrop.bind(this) : undefined}
                    onDragOver={aiReady ? this.onDragOver.bind(this) : undefined}
                    onDragLeave={aiReady ? this.onDragLeave.bind(this) : undefined}
                    onClick={aiReady ? function () { self.fileInputRef.current && self.fileInputRef.current.click(); } : undefined}
                    title={aiReady ? '' : L.aiDisabled}
                >
                    <input
                        ref={this.fileInputRef}
                        type="file"
                        accept="image/jpeg,image/png,image/webp,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,.xls,.xlsx,.csv,.pdf"
                        style={{ display: 'none' }}
                        onChange={this.onPickFile.bind(this)}
                    />
                    {this.state.uploading ? (
                        <div className="wiz-slots__dropzone-msg">
                            <div className="wiz-slots__spinner" />
                            <div>{L.uploadingMsg}</div>
                        </div>
                    ) : (
                        <div className="wiz-slots__dropzone-msg">
                            <div className="wiz-slots__dropzone-icon">⬇</div>
                            <div>{aiReady ? L.dropHint : L.aiDisabled}</div>
                            {aiReady ? <div className="wiz-slots__dropzone-hint">{L.pickFile}</div> : null}
                        </div>
                    )}
                </div>

                {this.state.uploadError ? (
                    <div className="wiz-slots__upload-err">{this.state.uploadError}</div>
                ) : null}
                {this.state.uploadNote ? (
                    <div className="wiz-slots__upload-note">{this.state.uploadNote}</div>
                ) : null}

                {rows.length > 0 ? (
                    <React.Fragment>
                        <div className="wiz-slots__head">
                            <span>{L.colCode}</span>
                            <span>{L.colName}</span>
                            <span>{L.colStart}</span>
                            <span>{L.colEnd}</span>
                            <span className="wiz-slots__col-price">{L.colWeekday}</span>
                            <span className="wiz-slots__col-price">{L.colWeekend}</span>
                            <span></span>
                        </div>
                        {rows.map(function (r, idx) {
                            var rowErr = v.rowErrors[idx];
                            var isAI = r && r._source === 'ai';
                            var rowClass = 'wiz-slots__row';
                            if (rowErr) rowClass += ' wiz-slots__row--err';
                            if (isAI) rowClass += ' wiz-slots__row--ai';
                            return (
                                <div className={rowClass} key={idx}>
                                    <input
                                        className="wiz-slots__input"
                                        value={r.slot_code || ''}
                                        onChange={(function (i) { return function (e) { self.update(i, 'slot_code', e.target.value); }; })(idx)}
                                    />
                                    <input
                                        className="wiz-slots__input"
                                        value={r.slot_name || ''}
                                        onChange={(function (i) { return function (e) { self.update(i, 'slot_name', e.target.value); }; })(idx)}
                                    />
                                    <input
                                        className="wiz-slots__input wiz-slots__input--time"
                                        value={r.start_hour || ''}
                                        placeholder="06:00:00"
                                        onChange={(function (i) { return function (e) { self.update(i, 'start_hour', e.target.value); }; })(idx)}
                                    />
                                    <input
                                        className="wiz-slots__input wiz-slots__input--time"
                                        value={r.end_hour || ''}
                                        placeholder="08:00:00"
                                        onChange={(function (i) { return function (e) { self.update(i, 'end_hour', e.target.value); }; })(idx)}
                                    />
                                    <NumberBox
                                        className="wiz-slots__input wiz-slots__input--num"
                                        value={Number(r.weekday_price) || 0}
                                        format="#,##0"
                                        min={0}
                                        showSpinButtons={false}
                                        onValueChanged={(function (i) { return function (e) { self.update(i, 'weekday_price', e.value == null ? 0 : e.value); }; })(idx)}
                                    />
                                    <NumberBox
                                        className="wiz-slots__input wiz-slots__input--num"
                                        value={Number(r.weekend_price) || 0}
                                        format="#,##0"
                                        min={0}
                                        showSpinButtons={false}
                                        onValueChanged={(function (i) { return function (e) { self.update(i, 'weekend_price', e.value == null ? 0 : e.value); }; })(idx)}
                                    />
                                    <button
                                        type="button"
                                        className="wiz-slots__remove"
                                        onClick={(function (i) { return function () { self.remove(i); }; })(idx)}
                                    >×</button>
                                    {rowErr ? <div className="wiz-slots__rowerr">{rowErr}</div> : null}
                                </div>
                            );
                        })}
                    </React.Fragment>
                ) : null}
                <button type="button" className="wiz-slots__add" onClick={this.add.bind(this)}>
                    {L.addRow}
                </button>
            </div>
        );
    }
}
